import React, { FC } from "react";
import { Form, Select } from "antd";
import { FormInstance } from "antd/lib/form";

interface SelectFormItemProps {
  title?: string;
  data: any[];
  onChange: (value: any) => void;
  id: string;
  form: FormInstance<any>;
  labelColSpan?: number;
  initialValue?: number;
  size?: "small" | "middle" | "large";
  className?: string;
  disabled?: boolean;
  colon?: boolean;
  bordered?: boolean;
}

const SelectFormItem: FC<SelectFormItemProps> = ({
  title,
  data = [],
  onChange,
  id,
  form,
  labelColSpan = 8,
  initialValue,
  size = "small",
  className = "",
  disabled = false,
  colon = true,
  bordered = true,
}) => {
  return (
    <Form.Item
      style={{
        marginTop: 0,
      }}
      labelCol={{ span: labelColSpan }}
      label={title || undefined}
      name={id}
      initialValue={initialValue || data?.[0]?.value}
      className={className}
      colon={colon}
    >
      <Select
        labelInValue
        onChange={(value) => {
          onChange(value);
        }}
        size={size}
        options={data}
        disabled={disabled}
        bordered={bordered}
      />
    </Form.Item>
  );
};

export default SelectFormItem;
